import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['code']

  connect() {
    this.removeWhiteSpaces()
  }

  removeWhiteSpaces() {
    this.codeTargets.forEach(target => {
      target.innerHTML = target.innerHTML.trim()
    })
  }
}
